package ai.beakman.undercover.i18n

/** Textos da UI em português (pt-BR). Fonte da verdade do inventário de chaves. */
object StringsPt : Strings {
    // --- App / branding / splash ---
    override val appTitle = "UNDERCOVER"
    override val webBrandTitle = "O INFILTRADO"
    override val webBrandTagline = "Quem é você?"
    override val splashContentDescription = "Undercover"
    override val webHomeHeroAlt = "O Infiltrado"

    // --- Home: escolha de modo ---
    override val homeHowToPlay = "Como vão jogar?"
    override val modeLocalTitle = "Local"
    override val modeLocalSubtitle = "Passem um celular entre amigos na mesma sala."
    override val modeOnlineTitle = "Online"
    override val modeOnlineSubtitleShared = "Cada um no seu celular, por um código."
    override val modeOnlineSubtitleWeb = "Cada um no seu aparelho, por um código."
    override val onlineSoonTitle = "Modo online"
    override val onlineSoonBody = "Chega na próxima fase (Firestore já provisionado)."

    // --- Navegação / voltar / sair ---
    override val backVoltar = "Voltar"
    override val backTrocarModo = "Trocar modo"
    override val backArrowVoltar = "← Voltar"
    override val backArrowSair = "← Sair"
    override val exitSair = "✕ Sair"

    // --- Setup local: jogadores ---
    override fun playersCount(n: Int) = "Jogadores ($n)"
    override val namesAddHint = "Adicione todos que vão jogar nesse celular."
    override val namesPlayerPlaceholder = "Nome do jogador"
    override fun minPlayers(n: Int) = "Mínimo de $n jogadores."
    override val continueNext = "Continuar →"

    // --- Setup: tema ---
    override val chooseTheme = "Escolha um tema"
    override val themeWillBeDrawn = "Uma palavra desse tema será sorteada."

    // --- Setup: infiltrados ---
    override val infiltratorsTitle = "Infiltrados"
    override val infiltratorSingular = "infiltrado"
    override val infiltratorPlural = "infiltrados"
    override val needTwoCommons = "É preciso ter ao menos 2 jogadores comuns."

    // --- Setup: tempo / iniciar ---
    override val discussionTimeTitle = "Tempo de discussão"
    override val startMatch = "Iniciar partida"

    // --- Reveal ---
    override fun revealPlayerXofN(i: Int, n: Int) = "Jogador $i de $n"
    override val youAre = "VOCÊ É"
    override val infiltrator = "INFILTRADO"
    override val hintLabel = "Dica:"
    override val yourAccompliceSingular = "Seu cúmplice:"
    override val yourAccomplicesPlural = "Seus cúmplices:"
    override val yourWord = "SUA PALAVRA"
    override fun themeWithEmoji(emoji: String, name: String) = "Tema: $emoji $name"
    override val revealDragHint = "Arraste para cima e segure\npara ver sua carta"
    override val revealHoldHint = "Segure para ver sua carta"
    override val nextPlayer = "Próximo jogador →"
    override val startDiscussion = "Começar discussão →"

    // --- Discussão / timer ---
    override val discussionPrompt = "Façam perguntas uns aos outros. Quem é o infiltrado?"
    override val goToVote = "Ir para votação"

    // --- Votação ---
    override val voteTitle = "Votação"
    override fun voteTurnOf(name: String) = "Vez de $name"
    override fun voteChooseSuspectsLocal(n: Int) = "Escolha $n suspeito(s) (não pode votar em si)"
    override val voteWhoIsInfiltrator = "Quem é o infiltrado?"
    override fun voteChoosePlayersOnline(n: Int) = "Escolha $n jogador(es)"
    override val voteRegisteredWaitingShared = "Voto registrado. Aguardando os outros."
    override fun voteRegisteredWaitingWeb(voted: Int, total: Int) =
        "Voto registrado. Aguardando os outros... ($voted/$total votaram)"
    override fun voteSelectedOfNParen(selected: Int, n: Int) = "$selected/$n selecionado(s)"
    override fun voteSelectedOfNSuffix(selected: Int, n: Int) = "$selected/$n selecionado(s)"
    override val voteConfirm = "Confirmar voto"
    override val voteSending = "Enviando..."
    override val voteConfirmArrow = "Confirmar voto →"
    override val voteConfirmAndResult = "Confirmar e ver resultado"
    override val voteStatusVoted = "votou"
    override val voteStatusVoting = "votando..."
    override val showResult = "Mostrar resultado"
    override fun showResultPartial(voted: Int, total: Int) = "Mostrar resultado ($voted/$total votaram)"
    override val seeResult = "Ver resultado"
    override fun seeResultPartial(voted: Int, total: Int) = "Ver resultado ($voted/$total votaram)"

    // --- Resultado ---
    override val resultPlayersWonEmoji = "🎉"
    override val resultInfiltratorWonEmoji = "🕵️"
    override val resultPlayersWon = "Jogadores venceram!"
    override val resultInfiltratorWon = "Infiltrado venceu!"
    override val resultCaughtAll = "Vocês pegaram o(s) infiltrado(s)."
    override val resultCaughtSome = "Pegaram um, mas não todos."
    override val resultCaughtNone = "O infiltrado enganou todo mundo."
    override val resultWordWas = "A palavra era"
    override val resultInfiltratorSingular = "Infiltrado"
    override val resultInfiltratorsPlural = "Infiltrados"
    override val resultVotesLabel = "Votos"
    override fun votesCountLocal(count: Int) = "$count voto(s)"
    override fun votesCountOnline(count: Int) = "$count voto(s)"
    override val playAgain = "Jogar novamente"
    override val configureNewGame = "Configurar novo jogo"

    // --- Online: menu / criar / entrar ---
    override val onlineModeLabel = "Modo Online"
    override val onlineMenuSubtitle = "Cada um no seu celular, na mesma sala."
    override val createRoomCardTitle = "Criar sala"
    override val createRoomCardSubtitle = "Você vira o host"
    override val joinRoomCardTitle = "Entrar com código"
    override val joinRoomCardSubtitle = "Junte-se a uma sala"
    override val createRoomDesc = "Escolha seu nome e o tema da partida."
    override val yourNamePlaceholder = "Seu nome"
    override val themeLabel = "Tema"
    override val createRoomCreating = "Criando..."
    override val createRoomError =
        "Não foi possível criar a sala. Verifique sua internet e tente de novo."
    override val joinRoomDesc = "Peça o código de 5 letras ao host."
    override val codePlaceholder = "CÓDIGO"
    override val joinEnter = "Entrar"
    override val joinEntering = "Entrando..."
    override fun joinRoomNotFound(code: String) =
        "Sala $code não encontrada. Confira o código com o host."
    override val joinRoomError =
        "Não foi possível entrar na sala. Verifique sua internet e tente de novo."

    // --- Online: erros / estado de sala ---
    override val actionSyncError =
        "Não foi possível sincronizar com a sala. Verifique sua internet e tente de novo."
    override val roomClosed = "A sala foi encerrada."
    override val loadingRoom = "Carregando sala..."
    override val roomLabel = "Sala"
    override val roomCodeLabel = "Código da sala"

    // --- Online: convite / cópia ---
    override val inviteButton = "📤 Convidar"
    override val inviteCopiedConfirm = "✓ Convite copiado!"
    override val copyCode = "Copiar código"
    override val copiedShared = "Copiado!"
    override val copiedWeb = "✓ Copiado!"
    override fun inviteMessage(code: String, baseUrl: String) =
        "Vem jogar O Infiltrado comigo! 🕵️\nEntra na sala: $baseUrl/sala/$code\nCódigo da sala: $code"

    // --- Online: lobby ---
    override val timeLabel = "Tempo"
    override val hostBadgeShared = "HOST"
    override val hostBadgeWeb = "⭐ HOST"
    override val playerYouSuffix = "(você)"
    override val lobbyStartWeb = "Começar"
    override val lobbyStartingWeb = "Começando..."
    override val waitingPlayersMin3 = "Aguardando jogadores (mín. 3)"
    override val waitingHostStartShared = "Aguardando o host iniciar a partida..."
    override val waitingHostStartWeb = "Aguardando o host começar..."

    // --- Online: reveal ---
    override fun revealTopBarReady(ready: Int, total: Int) = "Sua carta · $ready/$total prontos"
    override val imReady = "Estou pronto"
    override val readyConfirmed = "✓ Pronto"
    override fun waitingNReady(remaining: Int) = "Aguardando $remaining..."
    override val revealSecretCardCover = "CARTA SECRETA"
    override val revealHoldToPeek = "Segure para espiar"
    override val revealOnlyYouCanSee = "Só você pode ver. Solte para esconder."

    // --- Online: resultado ---
    override val resultLeaveRoom = "Sair da sala"
    override val resultPreparing = "Preparando..."
}
